import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  MIRRORS_LIST_DELETE_ITEM_API_URL,
  MIRRORS_LIST_DELETE_ITEM_MUTATION_KEY,
  MIRRORS_LIST_PERMISSIONS,
  MIRRORS_LIST_QUERY_KEY,
} from '@modules/mirrors-list/constants';
import { useToastStore } from '@modules/toast/store';

export default function useMirrorListItemDeleteMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [MIRRORS_LIST_DELETE_ITEM_MUTATION_KEY],
    mutationFn: (id) => fetchDelete<void>(
      MIRRORS_LIST_DELETE_ITEM_API_URL,
      {
        permission: MIRRORS_LIST_PERMISSIONS.DELETE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [MIRRORS_LIST_QUERY_KEY] });

      displayPresetToast('removed');
    },
  });
}
